/** The range the backend accepts (AccountManagement::set_retire_post_days). */
export const RETIRE_POST_DAYS_MIN = 1
export const RETIRE_POST_DAYS_MAX = 3650

const SCRAPED =
    'If this profile is collected by scraping, only its posts from this many days are checked for new comments.'

/**
 * What `retirePostDays` limits on each platform. A platform missing from here
 * has nothing that reads it, so the setting isn't offered.
 */
const EXPLANATIONS = new Map<string, string>([
    [
        'youtube',
        "Once a video is this many days old, its comments are no longer checked or collected, and new uploads older than this aren't added."
    ],
    ['tiktokad', 'Once an ad is this many days old, its comments are no longer collected.'],
    ['instagram', `With Fetch ads on, ads older than this are left out. ${SCRAPED}`],
    ['facebook', `With Fetch ads on, ads older than this are left out. ${SCRAPED}`],
    ['tiktokuser', SCRAPED]
])

/**
 * What `retirePostDays` limits on `platform` (a social media service short
 * name), or `undefined` where nothing reads it and the setting should be hidden.
 */
export function retirePostDaysExplanation(platform: string | null | undefined): string | undefined {
    return platform ? EXPLANATIONS.get(platform.toLowerCase()) : undefined
}

/** Whether `days` is a value the backend accepts: a whole number of days in range. */
export function isValidRetirePostDays(days: number): boolean {
    return Number.isInteger(days) && days >= RETIRE_POST_DAYS_MIN && days <= RETIRE_POST_DAYS_MAX
}
